import React, { useState } from "react";
import { Select, Checkbox } from "antd";
import useAcademicTerms from "../hooks/useAcademicTerms";

export default function TermSelect({ defaultValue, value, onChange, width, extended, allowOlderTerms = true }) {
  const [showOlder, setShowOlder] = useState(false);
  const termOptions = useAcademicTerms(extended || (allowOlderTerms && showOlder));

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <Select
        showSearch
        defaultValue={defaultValue}
        value={value}
        options={termOptions}
        onChange={onChange}
        popupMatchSelectWidth={false}
        style={{ width: width || "100%" }}
      />
      {allowOlderTerms && (
        <Checkbox
          checked={showOlder}
          onChange={(e) => setShowOlder(e.target.checked)}
        >
          Show older terms
        </Checkbox>
      )}
    </div>
  );
}
